<template>
  <footer class="footer">
    <div class="container footer__grid">
      <div class="footer__brand">
        <div class="brand">
          <img class="brand__logo" :src="require('@/assets/logo-mark.png')" alt="三剑客房产" />
          <strong>三剑客房产</strong>
        </div>
        <p>浙江嘉兴市三剑客房产经纪有限责任公司，深耕嘉兴本地房产经纪与置业咨询，为客户提供专业、透明、贴心的一站式服务。</p>
      </div>

      <div class="footer__col">
        <h4>快速导航</h4>
        <router-link to="/">首页</router-link>
        <router-link to="/properties">房源中心</router-link>
        <router-link to="/services">服务与咨询</router-link>
        <router-link to="/about">关于我们</router-link>
      </div>

      <div class="footer__col">
        <h4>服务范围</h4>
        <span>二手房买卖</span>
        <span>新房代理</span>
        <span>房屋租赁</span>
        <span>置业咨询</span>
      </div>

      <div class="footer__col">
        <h4>联系我们</h4>
        <span>地址：桐乡市崇福镇青阳中路137号崇福商业中心1幢904室</span>
        <span>电话：0573-8826 9137</span>
        <span>邮箱：service@sjk-fc.com</span>
        <span>工作时间：09:00 - 18:00</span>
      </div>
    </div>

    <div class="footer__bar">
      <div class="container footer__bar-inner">
        <span>© {{ year }} 浙江嘉兴市三剑客房产经纪有限责任公司 · 保留所有权利</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'TheFooter',
  computed: {
    year() {
      return new Date().getFullYear()
    },
  },
}
</script>

<style scoped>
.footer { background: var(--bg-dark); color: #c6d3df; }
.footer__grid {
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr 1.2fr;
  gap: 40px;
  padding: 64px 24px 48px;
}
.brand { display: flex; align-items: center; gap: 10px; margin-bottom: 16px; }
.brand__logo { height: 40px; width: auto; display: block; }
.brand strong { color: #fff; font-size: 18px; }
.footer__brand p { color: #94a7b8; font-size: 14px; margin: 0; max-width: 340px; }

.footer__col { display: flex; flex-direction: column; gap: 10px; }
.footer__col h4 { color: #fff; font-size: 15px; margin: 0 0 8px; }
.footer__col a, .footer__col span { color: #94a7b8; font-size: 14px; }
.footer__col a:hover { color: var(--accent-2); }

.footer__bar { border-top: 1px solid rgba(255, 255, 255, .08); }
.footer__bar-inner {
  display: flex; justify-content: space-between; flex-wrap: wrap; gap: 8px;
  padding: 18px 24px; font-size: 13px; color: #7c8fa0;
}

@media (max-width: 860px) {
  .footer__grid { grid-template-columns: 1fr 1fr; }
}
@media (max-width: 520px) {
  .footer__grid { grid-template-columns: 1fr; }
}
</style>
